<shared-ui-page-toolbars-header [text]="'uploader-small' | translate"></shared-ui-page-toolbars-header>

<div class="m-3">
  <div class="row g-3 align-items-stretch">
    <div class="col-12 col-lg-8 d-flex">
      <shared-ui-cards-card class="flex-fill">
        <div class="d-flex flex-column align-items-center gap-5 my-5 h-100 justify-content-center">
          <span
            *ngIf="downloaded"
            class="material-symbols-outlined d-inline-flex align-items-center justify-content-center rounded-circle bg-white shadow-sm border"
            style="width: 150px; height: 150px; font-size: 110px"
          >
            download_done
          </span>

          <span
            *ngIf="!downloaded"
            class="material-symbols-outlined d-inline-flex align-items-center justify-content-center rounded-circle bg-white shadow-sm border"
            style="width: 150px; height: 150px; font-size: 110px"
          >
            download
          </span>

          <div class="d-flex flex-column align-items-center">
            <p class="text-center">
              <strong>
                {{ 'tenant-name' | translate }}
                <span class="text-navy">Uploader </span>
              </strong>
              {{ 'uploader-description' | translate }}
            </p>

            <shared-ui-buttons-button text="Download" [type]="buttonType" (click)="goToDownloadPage()"></shared-ui-buttons-button>
          </div>
        </div>
      </shared-ui-cards-card>
    </div>

    <div class="col-12 col-lg-4 d-flex flex-column">
      <shared-ui-cards-card class="flex-grow-1 mb-3">
        <h2 class="fw-bold">{{ 'uploader-requirements' | translate }}</h2>
        <ul>
          <li>{{ 'uploader-requirements-os' | translate }}</li>
          <li>{{ 'uploader-requirements-disk-space' | translate }}</li>
        </ul>

        <h2 class="fw-bold mt-4">{{ 'uploader-important' | translate }}</h2>
        <ul class="mb-0">
          <li>{{ 'uploader-important-text' | translate }}</li>
        </ul>
      </shared-ui-cards-card>

      <shared-ui-cards-card class="flex-grow-1">
        <h2 class="fw-bold">{{ 'uploader-installer-options' | translate }}</h2>

        <ul class="mb-0">
          <li>
            <strong>{{ 'uploader-installer-option-one' | translate }}</strong>
            <span class="text-muted"> {{ 'uploader-installer-option-one-description' | translate }}</span>
          </li>
          <li>
            <strong>{{ 'uploader-installer-option-two' | translate }}</strong>
            <span class="text-muted"> {{ 'uploader-installer-option-two-description' | translate }}</span>
          </li>
        </ul>
      </shared-ui-cards-card>
    </div>
  </div>
</div>
